<template>
	<svg
		class="gallery-play-button"
		width="80"
		height="80"
		viewBox="0 0 80 80"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<circle
			class="gallery-play-button__circle"
			cx="40"
			cy="40"
			r="36"
			stroke="white"
			stroke-width="8"
		/>
		<path
			d="M26.3999 22.9933C26.3996 20.6928 28.8731 19.2547 30.8523 20.4046L60.1153 37.4077C62.0945 38.5577 62.0948 41.4333 60.116 42.5838L30.8576 59.595C28.8788 60.7455 26.4048 59.308 26.4045 57.0075L26.3999 22.9933Z"
			fill="white"
		/>
	</svg>
</template>
<style lang="scss" scoped>
.gallery-play-button {
	width: 3rem;
	height: 3rem;

	&__circle {
		fill: $color-primary;
	}

	@include media-query-up($breakpoint-small) {
		width: 5rem;
		height: 5rem;
	}

	@include media-query-up($breakpoint-extralarge) {
		width: 8rem;
		height: 8rem;
	}
}
</style>
